import { render } from "./OrdersSkeleton.vue?vue&type=template&id=5d8a2b66&ts=true"
import script from "./OrdersSkeleton.vue?vue&type=script&lang=ts"
export * from "./OrdersSkeleton.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./OrdersSkeleton.vue?vue&type=style&index=0&id=5d8a2b66&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__